export default __webpack_public_path__ + "static/media/darknet.c899d1d4.svg";